const waitForAnimation = (el, type = 'animation') => {
    if (!el) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        const _end = () => {
            el.removeEventListener(`${type}end`, _end);
            resolve();
        };
        el.addEventListener(`${type}end`, _end);
    });
};
function forwardEvent(e, el) {
    if (e.defaultPrevented) {
        return;
    }
    el.dispatchEvent(new window.Event(e.type));
}
/*
 * Returns true if the element contains a slot with a given name
 * or if the element has only one slot (only when the "slotName" is not passed)
 * */
function slotFilled(el, slotName) {
    if (slotName) {
        return !!el?.querySelector(`[slot="${slotName}"`);
    }
    return !!el?.firstChild;
}

export { forwardEvent as f, slotFilled as s, waitForAnimation as w };
